import styled from 'styled-components';

export const BellWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  cursor: pointer;
  border: 1px solid transparent;

  &:focus,
  &:active,
  &:focus-visible {
    border: 1px solid ${({ theme }): string => theme.admanColors!.blue.light.fg[4]};
  }

  svg {
    margin: ${({ theme }): string =>
      `${theme.spacers!.spacer02} 5px ${theme.spacers!.spacer02} ${theme.spacers!.spacer02}`};

    path:first-child {
      fill: ${({ theme, disabled }): string =>
        disabled ? theme.admanColors!.blue.light.fg[5] : theme.admanColors!.blue.light.fg[4]};
    }
  }
`;
export const StyledWrapper = styled.div`
  display: flex;
  position: relative;
`;

export const StyledContent = styled.div`
  position: absolute;
  top: 40px;
  right: 16px;
`;
